module.exports = __webpack_public_path__ + "img/area-limit-bg.bae0ff75.png";